import React, { ReactNode } from 'react'
import { Modal } from 'antd'
import styled from '@emotion/styled'

interface ModalProps {
  type: 'warning' | 'confirm'
  content: string | ReactNode
  centered?: boolean
  onCancel?: () => void
  onOk?: () => void
  okText?: string
  cancelText?: string
}

const { confirm, warning } = Modal

const CustomModal = ({
  type,
  content,
  onCancel,
  onOk,
  okText,
  cancelText
}: ModalProps) => {
  const baseProps = {
    onCancel,
    onOk,
    cancelText: cancelText ? cancelText : 'Cancel',
    okText: okText ? okText : 'Ok',
    okButtonProps: {
      type: 'default' as const
    },
    cancelButtonProps: {
      type: 'ghost' as const
    }
  }

  if (type === 'warning')
    return warning({
      ...baseProps,
      title: <ModalTitle className='cl-text-warning'>Warning!</ModalTitle>,
      content: <span data-testid='warning-text-quoted'>{content}</span>
    })

  if (type === 'confirm')
    return confirm({
      ...baseProps,
      title: <ModalTitle className='cl-text-warning'>Confirm!</ModalTitle>,
      content: <span data-testid='confirm-text-quoted'>{content}</span>
    })
}

const ModalTitle = styled.span`
  font-weight: 600;
`

export default CustomModal
